import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import HowItWorks from './pages/HowItWorks';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import ServiceDetail from './pages/ServiceDetail';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import { organizationLd, websiteLd } from './lib/structuredData';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <Helmet>
          <html lang="en-GB" />
          <meta name="geo.region" content="GB" />
          <meta name="geo.placename" content="Leicester" />
          <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
          <meta name="googlebot" content="index, follow" />
          <link rel="alternate" hrefLang="en-GB" href="https://residentialsupport.co.uk/" />
          <link rel="alternate" hrefLang="x-default" href="https://residentialsupport.co.uk/" />
          <script type="application/ld+json">{JSON.stringify(organizationLd)}</script>
          <script type="application/ld+json">{JSON.stringify(websiteLd)}</script>
        </Helmet>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:id" element={<ServiceDetail />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
            </Routes>
          </main>
          <Footer />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
